export const TOTAL_SPEACIAL_OVER_TIME_TYPE = {
  LEVEL_1: 1,
  LEVEL_2: 2,
  LEVEL_3: 3,
};
export const TOTAL_SPEACIAL_OVER_TIME_TEXT = '特別時間外割増';
